import { PUBLIC_PREVENT_POLLING, PUBLIC_MAINTENANCE_MODE_ON } from "$env/static/public";

export const PREVENT_POLLING = PUBLIC_PREVENT_POLLING === "true";
export const MAINTENANCE_MODE_ON = PUBLIC_MAINTENANCE_MODE_ON === "true";
export const DEFAULT_DEBOUNCE_MS = 300;
export const LEFT_SIDEPANEL_WIDTH_PX = 250;
export const PAGE_SIZE = 20;
